import React, { useEffect, useRef } from "react";
import {
  Dialog, DialogTitle, DialogContent,
  DialogActions, Button,Box,
  Select,
  Typography,
  Chip,
  MenuItem,
} from '@mui/material';

export function MultiSelectDialog({
  name,
  open,
  onConfirm,
  onClose,
  onChange,
  onDelete,
  value = [],
  treeData = [],
  placeholder="Please select",
  required = true,
  fullWidth = true,
  ...other
}) {

  const initialValueRef = useRef(value);

  useEffect(() => {
    if (open) initialValueRef.current = value;
    // eslint-disable-next-line
  }, [open]);

  const handleClear = () => {
    initialValueRef.current = [];
    onConfirm([]);
  };
  const handleCancel = () => {
    onChange({ target: { value: initialValueRef.current.map((item) => item.id) } });
    onClose();
  };
  const handleConfirm = () => {
    onConfirm(Array.from(value));
    onClose();
  };

  return <Dialog open={open} onClose={handleCancel} fullWidth maxWidth="sm">
      <DialogTitle>{name}</DialogTitle>
      <DialogContent>
        <Box sx={{ minHeight: 50, overflowY: 'auto', border: '1px solid #ddd', borderRadius: 1, p: 1 }}>
          <Select
            multiple
            fullWidth
            value={value.map((item) => item.id)}
            onChange={onChange}
            displayEmpty={true}
            renderValue={() => {
              if (value.length === 0) {
                return (
                  <Typography color="text.secondary" sx={{ opacity: 1, fontWeight: 500, fontSize: '0.875rem' }}>
                    {placeholder}
                  </Typography>
                );
              }
              return (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {value.map((item) => {
                  return (
                  <Chip key={item.id} label={item.label} onMouseDown={(event) => {event.stopPropagation();}} onDelete={onDelete(item.id)} sx ={{fontSize: "0.875rem"}} />
                )})}
              </Box>
            )}}
            {...other}
          >
            {treeData.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClear}>Clear all</Button>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button onClick={handleConfirm} variant="contained">Confirm</Button>
      </DialogActions>
    </Dialog>
}



